// deno-fmt-ignore-file
import { NumberKey } from '../../types/record.mjs';
import { CreateRecord } from './record-create.mjs';
export function FromNumberKey(_key, value) {
    const result = CreateRecord(NumberKey, value);
    return result;
}
